import * as types from "./mutation-types";

export default {
  [types.SET_BESTS](state, payload) {
    const { available_bests, user_bests, symbols_quotes } = payload;
    state.available_bests = available_bests;
    state.user_bests = user_bests
      ? user_bests.map((item) => {
          return {
            ...item,
            bo_profit: 0,
            mask: null,
            closed_pnl: null,

            // mask: { pnl: 100 },
            // closed_pnl: null,
          };
        })
      : [];
    state.symbols_data = symbols_quotes;
  },

  [types.SET_BESTS_HISTORY](state, payload) {
    state.history = payload;
  },

  [types.UPDATE_BEST](state, payload) {
    const { bo_id, new_pnl } = payload;
    const index = state.user_bests.findIndex((item) => item.bo_id == bo_id);
    const new_bo = { ...state.user_bests[index] };
    new_bo.bo_profit = new_pnl;
    state.user_bests.splice(index, 1, new_bo);
  },

  [types.CLOSE_BEST](state, payload) {
    // console.log(payload);

    const { type, datetime, data } = payload;
    const { best_order_id, order_symbol, order_type, pnl } = data[0];

    const mask = {
      pnl: Number(pnl),
    };

    const index = state.user_bests.findIndex((item) => item.bo_id == best_order_id);
    if (index != -1) {
      state.user_bests[index].closed_pnl = Number(pnl);
      state.user_bests[index].mask = mask;

      // console.log("mask", payload);
    }
  },

  [types.REMOVE_BEST](state, payload) {
    const index = state.user_bests.findIndex((item) => item.bo_id == payload);
    if (index != -1) {
      state.user_bests.splice(index, 1);
      // console.log("remove best", index);
    }
  },
};
